import { DayTimeType } from '../../../DayTimeAndRange/DayTime/types';

/**
 * Counts the distinct weekdays that have a time set in a DAYTIME schedule.
 * Days with an empty / null time are not counted.
 */
export const getScheduledDayCount = (schedule?: DayTimeType[]): number => {
  if (!schedule?.length) return 0;

  const scheduledDays = new Set<string>();
  schedule.forEach((entry) => {
    if (entry.time) {
      entry.days?.forEach((day) => scheduledDays.add(day));
    }
  });

  return scheduledDays.size;
};
